import { Box, Typography } from '@mui/material'

interface NoTableResultsProps {
  text: string
}

export default function NoTableResults({ text }: NoTableResultsProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
      }}
    >
      <Typography variant="h6" color="text.secondary">
        {text}
      </Typography>
    </Box>
  )
}
